<template>
  <Modal v-model="visible" :visible="getShowLog" :title="title" :width="width" :close-on-click-modal="false" @close="close" :mask-closable="false" :closable="false">
    <Table ref="tableLog" :columns="columns" :data="logData" border></Table>
    <page :total="total" :current="pageIndex" :page-size="pageSize" @on-change="currentChange" show-elevator show-sizer @on-page-size-change="pageSizeChange"></page>

    <div slot="footer">
        <Button size="large" @click="close"> 关 闭 </Button>
    </div>
  </Modal>
</template>

<script>
import axios from '@/libs/api.request'
import Tables from '_c/tables'
export default {
  name: 'backUpStorageLog',
  props: {

    title: { // 日志头部
      type: String || Number,
      default: '操作日志'
    },

    defaultData: { // 默认数据
      type: Array,
      default () {
        return []
      }
    },

    visible: { // 是否显示日志模态框
      type: Boolean,
      default: false
    },

    logId: {
      type: Number,
      default: undefined
    }, // 日志ID

    api: {
      type: String,
      default: undefined
    }, // 请求接口的api

    keys: { // 自定义table字段
      type: Array,
      default: () => []
    },

    slotContent: { // 是否自定义插入操作内容节点
      type: Boolean,
      default: false
    },

    query: { // 自定义table字段
      type: Object,
      default: () => ({})
    },

    width: {
      type: String,
      default: '56%'
    }

  },
  components: {
    Tables
  },
  data () {
    return {
      logData: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      columns: [
        { title: '序号', type: 'index', width: 80, align: 'center' },
        { title: '内容', key: 'operation', ellipsis: true, tooltip: true, align: 'center' },
        { title: '操作时间', key: 'createdAt', ellipsis: true, tooltip: true, align: 'center' },
        { title: '操作人', key: 'createName', ellipsis: true, tooltip: true, align: 'center' }
      ]
    }
  },

  computed: {
    getShowLog () {
      if (this.visible) {
        const def = this.defaultData
        if (def && Array.isArray(def) && def.length > 0) {
          this.$nextTick()
        } else {
          this.resetLogTable()
          this.getLogList()
        }
      }

      return this.visible
    }
  },

  methods: {
    close () {
      this.$emit('closeModal', false)
    },
    getLogList (current) {
      const { query, pageSize } = this
      this.logData = []
      let params = {
        pageSize,
        pageIndex: current,
        currentPage: current,
        ...query
      }

      // const url = (!this.logId || this.logId instanceof Object) ? this.api : `${this.api}/${this.logId}`
      if (this.logId instanceof Object) {
        params = {
          ...params,
          ...this.logId
        }
      }

      axios.request({
        url: this.api,
        method: 'get',
        params: { ...params }
      }).then(res => {
        const { data } = res
        let { items } = data || {}
        const { total = 0 } = data || {}

        this.total = total

        items = (items || []).map(row => ({
          ...row,
          createName: row.operator.name || row.operator.username
        }))

        this.logData = [...items]
      }).catch(_ => {
        this.resetLogTable()
      })
    },

    resetLogTable () {
      this.total = 0
      this.pageIndex = 1
      this.logData = []
    },

    currentChange (e) {
      this.pageIndex = e
      this.getLogList(e)
    },

    pageSizeChange (e) {
      this.pageSize = e
      this.getLogList()
    }
  }

}
</script>

<style lang="scss" scoped>
  @import "./styles";
</style>
